import { emit, events } from 'elc-service-bus';

export interface IProductSelection {
    [key: string]: string;
}

export class ProductSelectedUseCase {
    private productUrl: string;
    private skuId: string;
    private positionIndex: number;

    constructor(productUrl: string, skuId: string, positionIndex: number) {
        this.productUrl = productUrl;
        this.skuId = skuId;
        this.positionIndex = positionIndex;
    }

    public execute = async () => {
        emit(events.PRODUCT_CLICKED, { skuId: this.skuId, positionIndex: this.positionIndex });
        window.location.assign(this.productUrl);
    };
}
